import { render, staticRenderFns } from "./ModelDetail.vue?vue&type=template&id=22686364&scoped=true&"
import script from "./ModelDetail.vue?vue&type=script&lang=ts&"
export * from "./ModelDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ModelDetail.vue?vue&type=style&index=0&id=22686364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22686364",
  null
  
)

component.options.__file = "ModelDetail.vue"
export default component.exports